import { Badge, type BadgeVariant } from '@zyxantech/tux'

/** API severity → tux Badge variant. */
const VARIANT: Record<string, BadgeVariant> = {
  critical: 'danger',
  warning: 'warning',
  info: 'info',
}

/** Coloured severity pill for alarm tables. */
export function AlarmSeverityBadge({ severity }: { severity: string }) {
  return <Badge variant={VARIANT[severity] ?? 'default'}>{severity.toUpperCase()}</Badge>
}
